// src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect, useCallback } from 'react'; // 1. Importe useCallback
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // 2. Envolva a função `logout` com useCallback
  const logout = useCallback(() => {
    localStorage.removeItem('authToken');
    setUser(null);
    navigate('/');
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        const decodedUser = jwtDecode(token);
        if (decodedUser.exp * 1000 < Date.now()) {
          logout();
        } else {
          setUser(decodedUser);
        }
      } catch (error) {
        console.error("Token inválido:", error);
        logout();
      }
    }
  }, [logout]); // 3. Adicione `logout` ao array de dependências

  const login = async (username, password) => {
    const response = await api.post('/login', { username, password });
    const { token } = response.data;
    if (token) {
      localStorage.setItem('authToken', token);
      const decodedUser = jwtDecode(token);
      setUser(decodedUser);
      navigate('/dashboard');
    }
  };

  const hasPermission = (permission) => {
    return user?.roles?.includes(permission) ?? false;
  };

  const authContextValue = {
    user,
    isAuthenticated: !!user,
    login,
    logout,
    hasPermission,
  };

  return (
    <AuthContext.Provider value={authContextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};